<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-3">
				<h2>Podaj dane o wykształceniu</h2>
			</div>

			<v-container grid-list-md text-xs-center>
				<v-layout row wrap justify-center>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-select
							browser-autocomplete="off"
							:items="educationGrades"
							label="Wykształcenie"
							aria-label="label for education grade"
							for="step-education-data-component-education"
							id="step-education-data-component-education"
							v-model="stepData.education.grade"
						></v-select>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-textarea
							browser-autocomplete="off"
							label="Wykształcenie"
							aria-label="label for education description"
							for="step-education-data-component-education*"
							id="step-education-data-component-education*"
							v-model="stepData.education.description"
							outline
						></v-textarea>
					</v-flex>
					<v-flex xs3>
					</v-flex>

				</v-layout>
			</v-container>

			<div class="text-xs-center mb-3">
				<h2>Znajomość języków</h2>
			</div>

			<v-container grid-list-md text-xs-center>
				<v-layout row wrap justify-center>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-select
							browser-autocomplete="off"
							:items="languages"
							label="Język"
							aria-label="label for language"
							for="step-education-data-component-language"
							id="step-education-data-component-language"
							item-value="id"
							item-text="name"
							v-model="language.id"
						></v-select>
					</v-flex>
					<v-flex xs3>
					</v-flex>

					<v-flex xs3>
					</v-flex>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="off"
							label="Certyfikat znajomości języka"
							aria-label="label for language certificate"
							for="step-education-data-component-language-certificate"
							id="step-education-data-component-language-certificate"
							v-model="language.certificate"
						></v-text-field>
					</v-flex>
					<v-flex xs3>
					</v-flex>

				</v-layout>
			</v-container>

			<v-layout align-center justify-center column>
				<v-btn @click="addLanguage" pt-1 color="primary" class="mt-0 mb-4">
					Dodaj język
				</v-btn>
			</v-layout>

			<template v-if="languageNumber > 0">
				<v-layout row>
					<v-flex xs3/>
					<v-flex xs6 mb-4>
						<v-data-table
							:items="stepData.languageList"
							hide-headers
							hide-actions>
							<template slot="items" slot-scope="props">
								<td class="text-xs-center">{{ props.item.name}}</td>
								<td class="text-xs-center">{{ props.item.certificate}}</td>
								<td class="text-xs-center">
									<v-layout align-center justify-center column>
										<v-btn @click="removeLanguage(props.item)" pt-1 color="grey darken-1">
											Usuń język 
										</v-btn>
									</v-layout>
								</td>
							</template>
						</v-data-table>
					</v-flex>
				</v-layout>
			</template>

		</v-card>
		<v-btn color="blue"
			@click="$emit('step', 2)"
		>Wstecz
		</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 4, 'scope3')">
			Dalej
		</v-btn>
	</div>
</template>

<script>
	import {VolunteerLanguage} from "../../../../api/generated/VolunteerLanguage";

	export default {
		name: "StepEducationDataComponent",
		inject: ["parentValidator"],

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {
				languageNumber: 0,

				language: {
					id: undefined,
					name: "",
					certificate: ""
				},

				educationGrades: [
					"",
					"średnie",
					"wyższe",
				],

				languages: [],
			};
		},

		methods: {
			addLanguage() {
				if (this.language.id === "" || this.language.id === undefined ||
					this.stepData.languageList.find(el => el.id === this.language.id) !== undefined) return;
				this.languageNumber++;
				let newLanguage = Object.assign({}, this.language);
				newLanguage.name = this.languages.find(el => el.id === this.language.id).name;
				this.stepData.languageList.push(newLanguage);
				this.language.id = undefined;
				this.language.name = "";
				this.language.certificate = "";
			},

			removeLanguage(language) {
				this.languageNumber--;
				const index = this.stepData.languageList.indexOf(language);
				this.stepData.languageList.splice(index, 1);
			}
		},

		props: {
			stepData: Object,
		},

		mounted() {
			VolunteerLanguage.getRegistrationLanguages(this, successResponse => {
					this.languages = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się załadować języków", errorResponse);
				});
		},
	};
</script>

<style scoped>

</style>
